import { render, staticRenderFns } from "./attachmentViewer.vue?vue&type=template&id=663438bc&scoped=true"
import script from "./attachmentViewer.vue?vue&type=script&lang=js"
export * from "./attachmentViewer.vue?vue&type=script&lang=js"
import style0 from "./attachmentViewer.vue?vue&type=style&index=0&id=663438bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663438bc",
  null
  
)

export default component.exports